<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" slim>
    <form @submit.prevent="handleSubmit(checkForEndDate)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <ValidationProvider
            tag="div" class="form-group col-lg-4 col-md-12"
            rules="required"
            name="klant" v-slot="{ errors }">
          <label for="customer">Klant</label>
          <select
              id="customer"
              class="form-control"
              v-model="selectedCustomerId">
            <option :value="undefined" disabled>Kies een klant</option>
            <option
                :key="customer.id" :value="customer.id"
                v-for="customer in getCustomersSorted()">
              {{ customer.name }}
            </option>
          </select>
          <span class="text-red">{{ errors[0] }}</span>
        </ValidationProvider>

        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="startDate"
            labelText="startdatum" required
            vid="startDate" :crossFieldRules="['same_or_before_field:@endDate']"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="endDate"
            labelText="einddatum"
            vid="endDate" :crossFieldRules="['same_or_after_field:@startDate']"/>

        <div class="form-group col-lg-12">
          <label>Interne Referentie</label>
          <textarea class="form-control" id="textarea" rows="2" v-model="reference" maxlength="255"></textarea>
        </div>

        <h6 class="display-4 form-group col-lg-12 mt-3" style="font-size: 1.5em;">Order</h6>

        <NumberInputField
            class="form-group col-lg-4 col-md-12"
            labelText="uurtarief" required
            id="uurtarief"
            step=".01"
            v-model="order.baseHourlyRate"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="order.startDate"
            labelText="order startdatum" required
            vid="hourlyRateStartDate" :crossFieldRules="['same_or_before_field:@hourlyRateEndDate', 'same_or_after_field:@startDate', 'same_or_before_field:@endDate']"/>
        <DateInputField
            class="form-group col-lg-4 col-md-12" v-model="order.endDate"
            labelText="order einddatum" required
            vid="hourlyRateEndDate" :crossFieldRules="['same_or_after_field:@hourlyRateStartDate', 'same_or_before_field:@endDate']"/>
        <TextInputField class="form-group col-lg-12" labelText="Externe referentie" id="textarea" rows="2" v-model="order.message" maxlength="255"></TextInputField>
      </div>

      <div class="form-row align-items-center py-3">
        <div class="input-group col-6">
          <button
              type="submit" :disabled="invalid"
              class="btn-basic btn-fill-pulse">
            Opslaan
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import DateInputField from "@/components/inputFields/DateInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";
import TextInputField from "@/components/inputFields/TextInputField";

export default {
  name: "CreateContractFromUserComponent",
  components: {
    NumberInputField,
    DateInputField,
    ValidationProvider,
    ValidationObserver,
    TextInputField
  },
  props: ['userId'],
  data() {
    return {
      selectedCustomerId: undefined,
      startDate: "",
      endDate: "",
      order: {
        startDate: "",
        endDate: "",
        baseHourlyRate: undefined,
        message: ""
      },
      reference : "",
    };
  },
  computed: {
    ...mapGetters({
      customersMinimalInfo: "administrationCustomer/customersMinimalInfo"
    }),
  },
  created() {
    this.fetchCustomers();
  },
  methods: {
    ...mapActions("administrationTimeSheet", ['createContract']),
    ...mapActions("administrationCustomer", ['fetchCustomers']),
    ...mapMutations({
      addContractToSelectedUserDetail: "administrationUser/addContractToSelectedUserDetail"
    }),
    checkForEndDate() {
      if (!(this.endDate === "")) {
        if (confirm("Een einddatum toevoegen of aanpassen aan een contract kan ertoe leiden dat alle ingevulde timesheets van dit contract na de einddatum weggesmeten worden. Ben je zeker dat je dit contract wil opslaan?")) {
          this.saveContract();
        }
      } else {
        this.saveContract();
      }
    },
    saveContract() {
      const orderMessage = this.order.message === "" ? null : this.order.message;
      const createContractDto = {
        userId: this.userId,
        customerId: this.selectedCustomerId,
        startDate: this.startDate,
        endDate: this.endDate,
        order: {
          startDate: this.order.startDate,
          endDate: this.endDate === null ? null : this.order.endDate,
          baseHourlyRate: this.order.baseHourlyRate,
          message: orderMessage,
        },
        reference: this.reference
      };
      this.createContract(createContractDto)
          .then(response => {
            this.addContractToSelectedUserDetail(response.data);
            this.resetFields();
            this.$emit('contractAdded');
          });
    },
    resetFields() {
      this.selectedCustomerId = undefined;
      this.startDate = "";
      this.endDate = "";
      this.order.startDate = "";
      this.order.endDate = "";
      this.order.baseHourlyRate = undefined;
      this.order.message = "",
      this.reference = "";
    },
    getCustomersSorted: function () {
      return [...this.customersMinimalInfo].sort((first, second) => {
        const nameFirst = first.name.toUpperCase();
        const nameSecond = second.name.toUpperCase();
        if (nameFirst < nameSecond) {
          return -1;
        }
        if (nameFirst > nameSecond) {
          return 1;
        }
        return 0;
      });
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>
